import { createContext, useContext, type ReactNode } from "react";

export interface WorkflowRunnerApi {
  /** Advance to the next module in the runner. Optional patch is persisted under the current module's state. */
  complete: (patch?: unknown) => void;
  /** Step back to the previous module. */
  back: () => void;
  /** Skip the current module without persisting state. */
  skip?: () => void;
  /** Persist a state patch into work_orders.data.modules[current_module_key] WITHOUT advancing. */
  persist: (patch: unknown) => Promise<void>;
  /** Mark the work order completed and jump to the terminal workflow_complete stage. */
  markCompleted: (patch?: unknown) => Promise<void>;
  /** Current persisted state for the active module (hydrated from work_orders.data on mount). */
  state: unknown;
  workOrderId: string | null;
  applianceId: string;
  workflowKey: string;
}

const Ctx = createContext<WorkflowRunnerApi | null>(null);

export function WorkflowRunnerProvider({
  value,
  children,
}: {
  value: WorkflowRunnerApi;
  children: ReactNode;
}) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

/** Returns the runner API when the component is rendered inside WorkflowRunner; null otherwise. */
export function useWorkflowRunner(): WorkflowRunnerApi | null {
  return useContext(Ctx);
}
